module.exports = "/assets/data/72cfb81cb0fd2627df12e322bdbf9384-IP6.data.json";